import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAdmin = false,
}) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    // You can replace this with a loading spinner component
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <div>Loading...</div>
      </div>
    );
  }

  if (!user) {
    // Redirect to login page but save the attempted location
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // If requireAdmin is true, check if user has admin role
  if (requireAdmin) {
    // Accept various admin role formats
    const userRole = user.role?.toLowerCase();
    const isAdmin =
      userRole === 'admin' ||
      userRole === 'superadmin' ||
      userRole === 'super_admin' ||
      user.role === 'SUPER_ADMIN' ||
      user.role === 'ADMIN';

    if (!isAdmin) {
      console.warn('User role check failed:', {
        expectedRoles: [
          'admin',
          'superadmin',
          'super_admin',
          'ADMIN',
          'SUPER_ADMIN',
        ],
        actualRole: user.role,
        user: user,
      });
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return <>{children}</>;
};
